<template>
    <v-card v-bind="{ loading }" outlined style="overflow: hidden">
        <v-row no-gutters>
            <v-col cols="12" lg="3">
                <form-table-row label="ECO No" v-bind="{ ...attrs__row }"> <v-text-field v-model="form.bom.ECO_NO" v-bind="{ ...attrs__field }" @input="emit" /> </form-table-row>
            </v-col>
            <v-col cols="auto" class="d-none d-lg-block"> <v-divider vertical /> </v-col>
        </v-row>
        <v-divider />
        <v-row no-gutters>
            <v-col cols="12" lg="3">
                <form-table-row label="품번" v-bind="{ ...attrs__row }"> <v-text-field v-model="form.bom.MODEL_CODE" v-bind="{ ...attrs__field }" @input="emit" /> </form-table-row>
            </v-col>
            <v-col cols="12" lg="auto"> <v-divider class="d-none d-lg-block" vertical /> <v-divider class="d-block d-lg-none" /> </v-col>
            <v-col cols="12" lg="3">
                <form-table-row label="품명" v-bind="{ ...attrs__row }"> <v-text-field v-model="form.bom.MODEL_NAME" v-bind="{ ...attrs__field }" @input="emit" /> </form-table-row>
            </v-col>
            <v-col cols="12" lg="auto"> <v-divider class="d-none d-lg-block" vertical /> <v-divider class="d-block d-lg-none" /> </v-col>
            <v-col cols="12" lg="3">
                <form-table-row label="Rev." v-bind="{ ...attrs__row }"> <v-text-field v-model="form.bom.REVISION" v-bind="{ ...attrs__field }" @input="emit" /> </form-table-row>
            </v-col>
            <v-col cols="12" lg="auto"> <v-divider class="d-none d-lg-block" vertical /> <v-divider class="d-block d-lg-none" /> </v-col>
            <v-col cols="12" lg="">
                <form-table-row label="Rank" v-bind="{ ...attrs__row }"> <v-text-field v-model="form.bom.RANK" v-bind="{ ...attrs__field }" @input="emit" /> </form-table-row>
            </v-col>
        </v-row>
        <v-divider />
        <!-- <template v-if="!isCreate">
            <mes-bom-form-clone v-model="form" @input="emit" />
            <v-divider />
        </template> -->
        <v-row no-gutters>
            <v-col cols="12" lg="3">
                <form-table-row label="시방 일자" v-bind="{ ...attrs__row }"> <v-text-field v-model="form.bom.ECO_DATE" type="date" v-bind="{ ...attrs__field }" @input="emit" /> </form-table-row>
            </v-col>
            <v-col cols="12" lg="auto"> <v-divider class="d-none d-lg-block" vertical /> <v-divider class="d-block d-lg-none" /> </v-col>
            <v-col cols="12" lg="3">
                <form-table-row label="적용일자(시작)" v-bind="{ ...attrs__row }"> <v-text-field v-model="form.bom.DATE_FR" type="date" v-bind="{ ...attrs__field }" @input="emit" /> </form-table-row>
            </v-col>
            <v-col cols="12" lg="auto"> <v-divider class="d-none d-lg-block" vertical /> <v-divider class="d-block d-lg-none" /> </v-col>
            <v-col cols="12" lg="3">
                <form-table-row label="적용일자(종료)" v-bind="{ ...attrs__row }"> <v-text-field v-model="form.bom.DATE_TO" type="date" value="2099-12-31" v-bind="{ ...attrs__field }" @input="emit" /> </form-table-row>
            </v-col>
            <v-col cols="12" lg="auto"> <v-divider class="d-none d-lg-block" vertical /> <v-divider class="d-block d-lg-none" /> </v-col>
            <v-col cols="12" lg=""> </v-col>
        </v-row>
        <v-divider />
        <template v-if="!isCreate">
            <form-table-row label="변경사유" v-bind="{ ...attrs__row }"> <v-text-field v-model="form.bom.ECO_REASON" v-bind="{ ...attrs__field }" @input="emit" /> </form-table-row>
            <form-table-row v-model="form.bom.ECO_DETAIL" label="상세내역" v-bind="{ ...attrs__row }"> <v-textarea v-bind="{ ...attrs__field }" rows="2" @input="emit" /> </form-table-row>
        </template>
        <mes-bom-rows-form v-model="form" v-bind="{ isCreate }" @input="emit" />
    </v-card>
</template>

<script>
import { attrs_input__table, initManufacturingBom, initManufacturingBomRow } from "@/assets/variables";

import FormTableRow from "@/components/console/dumb/form-table-row.vue";
import MesBomRowsForm from "./mes-bom-rows-form.vue";
import MesBomFormClone from "./mes-bom-form-clone.vue";

const initForm = ({ bom, rows = [] } = {}) => ({
    bom: initManufacturingBom(bom),
    rows: rows.map(initManufacturingBomRow),
});

export default {
    components: {
        FormTableRow,
        MesBomRowsForm,
        MesBomFormClone,
    },
    props: {
        value: { type: Object, default: initForm },
        loading: { type: Boolean, default: false },
        isCreate: { type: Boolean, default: false },
        excelFile: { type: File, default: null },
    },
    data: () => ({
        form: initForm(),
    }),
    computed: {
        attrs__field() {
            return {
                ...attrs_input__table,
                ["class"]: "caption",
                ["dense"]: true,
                ["readonly"]: this.isCreate,
            };
        },
        attrs__row() {
            return {
                cols: "3",
                lg: "",
                maxWidth: "124px",
                contentClass: "pa-0",
            };
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync(form = this.value) {
            this.form = initForm(form);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>

<style></style>
